"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: "taskList",
      optConfig: {},
      formLabelWidth: "120px",
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currentId: null,
      currentItem: {},
      isShowModel: false,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {},
      form: {}
    };
  },
  computed: {
    userRole: function userRole() {
      return this.$store.getters.roles[0];
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0)"
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    this.queryEnumOptions();
    this.searchData();
  },
  methods: {
    queryEnumOptions: function queryEnumOptions() {
      var _this = this;
      var type_key = "PLAN_TASK_TYPE"; // 计划任务select
      var visitPurpose_key = "VISIT_PURPOSE"; // 拜访目的select
      var rtm_key = "STORE_RTM_TYPE"; // 门店RTM类型select
      var storeCategory_key = "STORE_CATEGORY"; // 客户类型select（零售店类别）
      var yesno_key = "Y_OR_N"; // 是与否
      var from_key = "TASK_FROM_TYPE"; // 来源类型
      var param = {
        configItemCodeList: [type_key, visitPurpose_key, rtm_key, storeCategory_key, from_key, yesno_key]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        _this.optConfig.planTypeOptions = data[type_key] || [];
        _this.optConfig.visitPurposeOptions = data[visitPurpose_key] || [];
        _this.optConfig.rtmOptions = data[rtm_key] || [];
        _this.optConfig.storeCategoryOptions = data[storeCategory_key] || [];
        _this.optConfig.taskFromOptions = data[from_key] || [];
        _this.optConfig.yesnoOptions = data[yesno_key] || [];
      });
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel("cancel");
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      this.$api.taskInfo.getList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal = {};
      this.searchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    formatterValues: function formatterValues(row, column, cellValue, index) {
      var item;
      switch (column.property) {
        case "nowTime":
          return cellValue && (0, _index.parseTime)(cellValue, "{y}-{m}-{d}");
        case "taskType":
          item = this.optConfig.planTypeOptions.find(function (item) {
            return item.code === cellValue;
          });
          return item ? item.name : cellValue;
        case "signBoardBidFlag":
          item = this.optConfig.yesnoOptions.find(function (item) {
            return item.code === cellValue;
          });
          return item ? item.name : cellValue;
        case "dueTime":
          return cellValue && (0, _index.parseTime)(cellValue, "{y}-{m}-{d}");
        case "readFlag":
          return cellValue === "Y" ? "已读" : "未读";
        default:
          return cellValue;
      }
    },
    detail: function detail(row) {
      this.form = (0, _objectSpread2.default)({
        storeAddress: "".concat(row.rtlRegion || "").concat(row.rtlCity || "").concat(row.rtlDistrict || "")
      }, row);
      this.isShowModel = true;
    },
    confirm: function confirm() {
      this.isShowModel = false;
    },
    downloadExcel: function downloadExcel() {
      var _this3 = this;
      if (this.isLoading) return;
      this.isLoading = true;
      var fileName = this.$t('sfe.route.tasklist');
      this.$api.taskInfo.exportTaskInfo(this.searchVal).then(function (res) {
        _this3.isLoading = false;
        (0, _index.downloadFileExcel)(fileName, res.data);
      }).catch(function (err) {
        _this3.isLoading = false;
      });
    }
  }
};